
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 45 45","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M30.415 3.5C36.527 3.5 41.5 8.472 41.5 14.582v15.833c0 6.112-4.972 11.085-11.082 11.085H14.585C8.473 41.5 3.5 36.528 3.5 30.418V14.585C3.5 8.473 8.472 3.5 14.582 3.5zM22.5 13c-5.24 0-9.5 4.26-9.5 9.5s4.26 9.5 9.5 9.5 9.5-4.26 9.5-9.5-4.26-9.5-9.5-9.5zm0 3.167a6.333 6.333 0 110 12.666 6.333 6.333 0 010-12.666zm11.083-6.334a1.584 1.584 0 10.001 3.168 1.584 1.584 0 000-3.168z","fill":"#000","fill-rule":"nonzero"}})])
          )
        }
      }
    